module.exports = function(service) {
	'use strict'
	service.factory('slugifyValidator', slugifyValidator);
	slugifyValidator.$inject = [];
	function slugifyValidator() {
		return function(value) {
			var slugReg = /^(?!-)(?!_)(?!.*?-_)(?!.*?_-)(?!.*?--)(?!.*?__)(?!.*-$)(?!.*_$)[a-z0-9_-]+$/g
	    	return slugReg.test(value);
		}

	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/slugifyValidatorService.js
// module id = 627
// module chunks = 0